import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainWrapper: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        height: "100%",
        flexDirection: "column",
        gap: 4,
    },
    tag: {
        marginBottom: 4,
    },
}));
